export type TenantUserScope = 'manage' | 'teacher' | 'student' | 'user'

export function resolveScopeByRole(role?: string | null): TenantUserScope {
  switch (role) {
    case 'teacher':
      return 'teacher'
    case 'student':
      return 'student'
    case 'tenant_user':
      return 'user'
    default:
      return 'manage'
  }
}

export function buildTenantPath(
  slug: string | undefined | null,
  scope: TenantUserScope,
  segment = 'dashboard'
): string {
  const normalizedSlug = (slug ?? '').trim()
  if (!normalizedSlug) {
    return '/'
  }

  const base =
    scope === 'manage'
      ? `/tenant/${normalizedSlug}`
      : `/tenant/${normalizedSlug}/${scope}`

  const normalizedSegment = (segment ?? '').replace(/^\/+/, '')

  if (!normalizedSegment) {
    return base
  }

  return `${base}/${normalizedSegment}`
}

export function resolveDefaultTenantRoute(
  role: string | undefined | null,
  slug: string | undefined | null
): string {
  const scope = resolveScopeByRole(role)
  return buildTenantPath(slug, scope, 'dashboard')
}

export function isScopeAllowedForRole(
  scope: TenantUserScope,
  role: string | undefined | null
): boolean {
  if (!role) {
    return scope === 'manage'
  }
  if (scope === 'teacher') {
    return role === 'teacher'
  }
  if (scope === 'student') {
    return role === 'student'
  }
  if (scope === 'user') {
    return role === 'tenant_user'
  }
  return role === 'tenant_admin' || role === 'super_admin'
}

export function guessScopeFromPath(path: string): TenantUserScope {
  if (/\/tenant\/[^/]+\/teacher(?:\/|$)/.test(path)) {
    return 'teacher'
  }
  if (/\/tenant\/[^/]+\/student(?:\/|$)/.test(path)) {
    return 'student'
  }
  if (/\/tenant\/[^/]+\/user(?:\/|$)/.test(path)) {
    return 'user'
  }
  return 'manage'
}
